module.exports = __webpack_public_path__ + "static/media/bg21.761d1e4c.jpg";